import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("聚合导出");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("明细导出");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("   ");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("查看");

import { computed, ref } from 'vue';
import { getTeamOrderList, getSalesmanTypeList, getTeamTypeList, checkOrderIsdelete, exportForAsync, getOrderStateList, freezeOrder } from '@/request';
import { exportOrderList } from '@/request/api';
import { getVexTableProps, dateTimeFormat, dateFormat } from '@/config';
import dayjs from 'dayjs';
import { ElMessageBox, ElMessage } from 'element-plus';
import { useStore } from 'vuex';
import OrderDetailModal from './component/OrderDetailModal.vue';
import CancelOrderModal from './component/cancelOrderModal';
import { useRouter, useRoute } from 'vue-router';
export default {
  name: 'TeamOrder',

  setup(__props) {
    const router = useRouter();
    const route = useRoute();
    const showOrderDetailModal = ref(false);
    const store = useStore();
    store.dispatch('getBranchList');
    const branchSelectList = computed(() => store.state.branchList);
    const salesmanTypeList = ref([]);
    getSalesmanTypeList().then(data => {
      salesmanTypeList.value = data;
    });
    const teamTypeList = ref([]);
    getTeamTypeList({
      type: 'supplierCategory'
    }).then(data => {
      teamTypeList.value = data;
      table.value.commitProxy('reload');
    });
    const payTypeList = [{
      id: '',
      text: '全部'
    }, {
      id: '2',
      text: '自主支付'
    }, {
      id: '1',
      text: '分享支付 '
    }, {
      id: '0',
      text: '线下结算'
    }, {
      id: '3',
      text: '扫码支付'
    }, {
      id: '4',
      text: '挂账结算'
    }, {
      id: '5',
      text: '挂账结算(个人垫资)'
    }, {
      id: '6',
      text: '挂账结算(团队垫资)'
    }, {
      id: '7',
      text: '货到付款'
    }, {
      id: '10',
      text: '余额支付'
    }, {
      id: '12',
      text: '团队余额支付(混合支付)'
    }];
    const dataTotal = ref(0);
    const exportAuth = ref(false);
    const form = ref({
      branchId: '',
      custName: '',
      orderCode: '',
      orderStatus: [],
      supplierName: '',
      supplierType: [],
      salesMan: '',
      businessCategory: [],
      payType: '',
      endTime: dayjs(Date.now()).format(dateFormat),
      startTime: dayjs(Date.now() - 7 * 24 * 60 * 60 * 1000).format(dateFormat),
      payStatus: '',
      prePaymentType: '',
      freezeStatus: ''
    });
    const formRef = ref();
    const total = ref(0);
    const tableOptions = getVexTableProps({
      columns: [{
        title: '发货方',
        field: 'branch_name',
        width: '150px',
        showOverflow: true
      }, {
        title: '订单编号',
        field: 'order_code_split',
        width: '200px',
        showOverflow: true
      }, {
        title: '订单状态',
        field: 'order_state',
        width: '150px',
        showOverflow: true
      }, {
        title: '冻结状态',
        field: 'freezeStatusText',
        width: '150px',
        showOverflow: true,
        visible: false
      }, {
        title: '团队名称',
        field: 'supplier_name',
        width: '200px',
        showOverflow: true
      }, {
        title: '团队类别',
        field: 'supplier_type_name',
        width: '150px',
        showOverflow: true
      }, {
        title: '业务员',
        field: 'link_man',
        width: '150px',
        showOverflow: true
      }, {
        title: '业务员类别',
        field: 'business_category',
        width: '150px',
        showOverflow: true
      }, {
        title: '联系电话',
        field: 'link_phone',
        width: '200px',
        showOverflow: true
      }, {
        title: '客户名称',
        field: 'cust_name',
        width: '150px',
        showOverflow: true
      }, {
        title: '订单总额',
        field: 'total_price',
        width: '150px',
        showOverflow: true
      }, {
        title: '商品总额',
        field: 'real_time_price',
        width: '150px',
        showOverflow: true
      }, {
        title: '邮费',
        field: 'postage',
        width: '150px',
        showOverflow: true
      }, {
        title: '运输保险',
        field: 'delivery_insurance_amount',
        width: '150px',
        showOverflow: true
      }, {
        title: '支付金额类型',
        field: 'pre_payment_info',
        width: '200px',
        slots: {
          default: 'pre_payment_info'
        }
      }, {
        title: '客户支付方式',
        field: 'pay_type_name',
        width: '150px',
        showOverflow: true
      }, {
        title: '线上支付状态',
        field: 'pay_status',
        width: '150px',
        slots: {
          default: 'pay_status'
        }
      }, {
        title: '订单时间',
        field: 'create_at',
        width: '200px',
        showOverflow: true
      }, {
        title: '备注',
        field: 'order_note',
        width: '200px',
        showOverflow: true
      }, {
        title: '操作',
        slots: {
          default: 'operation'
        },
        width: '320px',
        fixed: 'right'
      }],
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            let params = _objectSpread(_objectSpread({
              page: page.currentPage,
              rows: page.pageSize
            }, form.value), {}, {
              orderStatus: form.value.orderStatus.join(','),
              supplierType: form.value.supplierType.join(','),
              businessCategory: form.value.businessCategory.join(','),
              payType: form.value.payType,
              prePaymentType: form.value.prePaymentType,
              freezeStatus: form.value.freezeStatus
            });

            if (route.query.orderCode) {
              params.orderCode = route.query.orderCode;
              params.startTime = '';
              params.endTime = '';
              form.value.startTime = '';
              form.value.endTime = '';
            }

            getTeamOrderList(params).then(data => {
              dataTotal.value = data.total;
              total.value = data === null || data === void 0 ? void 0 : data.totalPrice.toFixed(2);
              exportAuth.value = data.exportAuth;
              data.rows.forEach(item => {
                let typeObj = salesmanTypeList.value.find(type => Number(type.id) === item.business_category) || {};
                item.business_category = typeObj.text;
              });
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      }
    });
    const table = ref();

    function getPayStatus(row) {
      let {
        pay_type_name,
        pay_status
      } = row;

      switch (pay_type_name) {
        case '货到付款':
        case '扫码支付':
        case '分享支付':
          return pay_status == 0 ? '未支付' : pay_status == 2 ? '未支付' : '已支付';

        default:
          return '-';
      }
    }
    /** get_data 列表行 payDetailVoList：与后端顺序一致（混合支付先在线、后余额） */


    function getPayDetailList(row) {
      var _row$payDetailVoList;

      const list = (_row$payDetailVoList = row === null || row === void 0 ? void 0 : row.payDetailVoList) !== null && _row$payDetailVoList !== void 0 ? _row$payDetailVoList : row === null || row === void 0 ? void 0 : row.pay_detail_vo_list;
      return Array.isArray(list) ? list : [];
    }

    function reset() {
      formRef.value.resetFields();
      table.value.commitProxy('reload');
    }

    const orderDetail = ref(null);

    function see(row) {
      checkOrderIsdelete({
        __warn: true
      }, {
        params: {
          orderCode: row.order_code_split
        }
      }).then(data => {
        if (data.success) {
          showOrderDetailModal.value = true;
          orderDetail.value = row;
        }
      });
    }

    function exportFile() {
      exportForAsync(_objectSpread(_objectSpread({
        __repeat: true,
        __warn: true
      }, form.value), {}, {
        orderStatus: form.value.orderStatus.join(','),
        supplierType: form.value.supplierType.join(','),
        businessCategory: form.value.businessCategory.join(','),
        payType: form.value.payType,
        modularflag: 'supOrderDetail',
        fileName: '团队订单查询',
        count: dataTotal.value,
        methodName: exportOrderList.url
      }));
    }

    function gatherExport() {
      let startTime = +new Date(form.value.startTime);
      let endTime = +new Date(form.value.endTime);
      let maxTime = 1000 * 60 * 60 * 24 * 7;

      if (endTime - startTime > maxTime) {
        ElMessage.error('请选择7日以内的时间段进行导出');
        return;
      }

      let formData = _objectSpread(_objectSpread({}, form.value), {}, {
        orderStatus: form.value.orderStatus.join(','),
        supplierType: form.value.supplierType.join(','),
        businessCategory: form.value.businessCategory.join(','),
        payType: form.value.payType
      });

      let query = {};
      Object.keys(formData).forEach(key => {
        formData[key] && (query[key] = formData[key]);
      });
      router.push({
        name: 'orderGatherExport',
        query
      });
    } // 订单状态list


    const orderStateList = ref([]);
    getOrderStateList().then(res => {
      orderStateList.value = res.data.orderStateList;
    }); // 取消订单

    const cancelOrderModal = ref({
      show: false,
      data: {}
    });

    function cancelOrder(data) {
      cancelOrderModal.value = {
        show: true,
        data
      };
    }

    function withdrawFreeze(row) {
      ElMessageBox.confirm('冻结后，订单货款在商业“资金管理”模块不可提现', {
        title: '是否冻结订单货款？',
        type: 'warning'
      }).then(() => {
        freezeOrder({
          __warn: true,
          __repeat: true,
          orderCodeSplit: row.order_code_split,
          freezeStatus: "1"
        }).then(data => {
          if (!data.success) {
            ElMessage.error(data.message);
            return;
          }

          table.value.commitProxy('reload');
        });
      });
    }

    function unWithdrawFreeze(row) {
      ElMessageBox.confirm('是否确认解冻', {
        title: '提示'
      }).then(() => {
        freezeOrder({
          __warn: true,
          __repeat: true,
          orderCodeSplit: row.order_code_split,
          freezeStatus: "0"
        }).then(data => {
          if (!data.success) {
            ElMessage.error(data.message);
            return;
          }

          table.value.commitProxy('reload');
        });
      });
    }

    function getPrePaymentType(type) {
      const typeMap = {
        '1': '订单金额支付',
        '2': '预付金额支付'
      };
      return typeMap[type] || '-';
    }

    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_form, {
        model: form.value,
        ref_key: "formRef",
        ref: formRef,
        "label-width": "100px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "发货方",
              prop: "branchId"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                filterable: "",
                modelValue: form.value.branchId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.branchId = $event)
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(branchSelectList), item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    label: item.text,
                    value: item.id,
                    key: item.id
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "客户名称",
              prop: "custName"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.custName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.custName = $event),
                placeholder: "编码/名称"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "订单编号",
              prop: "orderCode"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.orderCode,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.orderCode = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "订单状态",
              prop: "orderStatus"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.orderStatus,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.orderStatus = $event),
                multiple: "",
                "collapse-tags": ""
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "全部",
                  value: ""
                }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderStateList.value, item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    label: item.orderStateDes,
                    value: item.orderStateCode,
                    key: item.orderStateCode
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "团队名称",
              prop: "supplierName"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.supplierName,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.supplierName = $event),
                placeholder: "账号/姓名"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "团队类别",
              prop: "supplierType",
              multiple: "",
              "collapse-tags": ""
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.supplierType,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.value.supplierType = $event),
                multiple: "",
                "collapse-tags": ""
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teamTypeList.value, item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    label: item.text,
                    value: item.id,
                    key: item.id
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "业务员",
              prop: "salesMan"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.salesMan,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.value.salesMan = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "业务员类别",
              prop: "businessCategory"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.businessCategory,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => form.value.businessCategory = $event),
                multiple: "",
                "collapse-tags": ""
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(salesmanTypeList.value, item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    label: item.text,
                    value: item.id,
                    key: item.id
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "支付方式",
              prop: "payType"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.payType,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => form.value.payType = $event)
              }, {
                default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(payTypeList, item => {
                  return _createVNode(_component_el_option, {
                    label: item.text,
                    value: item.id,
                    key: item.id
                  }, null, 8, ["label", "value"]);
                }), 64))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "支付状态",
              prop: "payStatus"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.payStatus,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => form.value.payStatus = $event)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "全部",
                  value: ""
                }), _createVNode(_component_el_option, {
                  label: "已支付",
                  value: "1"
                }), _createVNode(_component_el_option, {
                  label: "未支付",
                  value: "0"
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "开始时间",
              prop: "startTime"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: form.value.startTime,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => form.value.startTime = $event),
                type: "date",
                "value-format": _unref(dateFormat),
                placeholder: "订单开始时间"
              }, null, 8, ["modelValue", "value-format"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "结束时间",
              prop: "endTime"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: form.value.endTime,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => form.value.endTime = $event),
                type: "date",
                "value-format": _unref(dateFormat),
                placeholder: "订单结束时间"
              }, null, 8, ["modelValue", "value-format"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "支付金额类型",
              prop: "prePaymentType"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.prePaymentType,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => form.value.prePaymentType = $event)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "全部",
                  value: ""
                }), _createVNode(_component_el_option, {
                  label: "订单金额支付",
                  value: "1"
                }), _createVNode(_component_el_option, {
                  label: "预付金额支付",
                  value: "2"
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "提现冻结",
              prop: "freezeStatus"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.freezeStatus,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => form.value.freezeStatus = $event)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "全部",
                  value: ""
                }), _createVNode(_component_el_option, {
                  label: "是",
                  value: "1"
                }), _createVNode(_component_el_option, {
                  label: "否",
                  value: "0"
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), _createVNode(_component_el_row, {
        justify: "end"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Search",
          onClick: _cache[14] || (_cache[14] = $event => table.value.commitProxy('reload'))
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          icon: "Refresh",
          onClick: reset
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_grid, _mergeProps(_unref(tableOptions), {
        ref_key: "table",
        ref: table
      }), {
        tools: _withCtx(() => [exportAuth.value ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          onClick: gatherExport
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })) : _createCommentVNode("", true), exportAuth.value ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          onClick: exportFile,
          icon: "Download"
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        })) : _createCommentVNode("", true), _hoisted_5]),
        pay_status: _withCtx(({
          row
        }) => [_createElementVNode("span", null, _toDisplayString(getPayStatus(row)), 1)]),
        operation: _withCtx(({
          row
        }) => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "View",
          onClick: $event => see(row)
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 2
        }, 1032, ["onClick"])]),
        pre_payment_info: _withCtx(({
          row
        }) => [_createElementVNode("div", null, [_createElementVNode("div", null, _toDisplayString(getPrePaymentType(row.pre_payment_type)) + " " + _toDisplayString(row.pre_payment_type === 1 ? row.total_price : row.pre_payment_price || '-'), 1)])]),
        _: 1
      }, 16), _createVNode(OrderDetailModal, {
        modelValue: showOrderDetailModal.value,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => showOrderDetailModal.value = $event),
        data: orderDetail.value
      }, null, 8, ["modelValue", "data"]), _createVNode(_unref(CancelOrderModal), {
        modelValue: cancelOrderModal.value.show,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => cancelOrderModal.value.show = $event),
        data: cancelOrderModal.value.data,
        onSuccess: _cache[17] || (_cache[17] = $event => table.value.commitProxy('reload'))
      }, null, 8, ["modelValue", "data"])]);
    };
  }

};